import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API_BASE, timeout: 60000 });

let authToken = null;

export function setToken(token) {
  authToken = token;
}

client.interceptors.request.use((config) => {
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("token");
      setToken(null);
      window.location.href = "/login";
    }
    return Promise.reject(err);
  },
);

export const api = {
  login: (username, password) =>
    client.post("/auth/login", { username, password }).then((r) => r.data),
  stats: () => client.get("/stats/summary").then((r) => r.data),
  opportunities: (params = {}) =>
    client.get("/opportunities", { params }).then((r) => r.data),
  opportunity: (id) => client.get(`/opportunities/${id}`).then((r) => r.data),
  sources: () => client.get("/sources").then((r) => r.data),
  runs: (limit = 20) =>
    client.get("/crawl/runs", { params: { limit } }).then((r) => r.data),
  runDetail: (id) => client.get(`/crawl/runs/${id}`).then((r) => r.data),
  triggerCrawl: (payload) =>
    client.post("/crawl/run", payload).then((r) => r.data),
  downloadDoc: (opportunity_id, attachment_url) =>
    client
      .post("/documents/download", { opportunity_id, attachment_url })
      .then((r) => r.data),
  exportCsv: (active_only = true) =>
    client.post(`/export/csv?active_only=${active_only}`).then((r) => r.data),
  exportJson: (active_only = true) =>
    client
      .post(`/export/json?active_only=${active_only}`)
      .then((r) => r.data),
  newOpportunities: () =>
    client.get("/opportunities/new").then((r) => r.data),
  aiFilter: (payload) =>
    client.post("/filter/ai", payload).then((r) => r.data),
};
